"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightHightContrast = exports.lightWarning = exports.lightSuccess = exports.lightError = exports.lightInfo = exports.lightDefault = exports.heavyHightContrast = exports.heavyWarning = exports.heavySuccess = exports.heavyError = exports.heavyInfo = exports.heavyDefault = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
var resolveTypographyVariantStyles_1 = require("../utils/resolveTypographyVariantStyles");
var commonStyles = (_a = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: "none",
        borderRadius: '0.125rem',
        gap: '0.25rem',
        width: 'min-content',
        height: '1.25rem'
    },
    _a[".".concat(material_1.chipClasses.label)] = {
        padding: '0.125rem 0.5rem',
    },
    _a["&.".concat(material_1.chipClasses.labelMedium)] = {
        padding: '0.125rem 0.5rem',
    },
    _a["&.".concat(material_1.chipClasses.labelSmall)] = {
        padding: '0.125rem 0.5rem',
    },
    _a);
exports.heavyDefault = {
    props: { variant: 'heavyDefault' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--primary-500, ".concat(theme.palette.primary.main, ")"), color: "var(--text-light, ".concat(theme.palette.text.light, ")") }));
    },
};
exports.heavyInfo = {
    props: { variant: 'heavyInfo' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--info-500, ".concat(theme.palette.info.main, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.heavyError = {
    props: { variant: 'heavyError' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--error-700, ".concat(theme.palette.error.dark, ")"), color: "var(--text-light, ".concat(theme.palette.text.light, ")") }));
    },
};
exports.heavySuccess = {
    props: { variant: 'heavySuccess' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--success-700, ".concat(theme.palette.success.dark, ")"), color: "var(--text-light, ".concat(theme.palette.text.light, ")") }));
    },
};
exports.heavyWarning = {
    props: { variant: 'heavyWarning' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--warning-700, ".concat(theme.palette.warning.dark, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.heavyHightContrast = {
    props: { variant: 'heavyHC' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
    },
};
exports.lightDefault = {
    props: { variant: 'lightDefault' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), border: "1px solid var(--primary-500, ".concat(theme.palette.primary.main, ")") }));
    },
};
exports.lightInfo = {
    props: { variant: 'lightInfo' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--info-300, ".concat(theme.palette.info.light, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), border: "1px solid var(--primary-500, ".concat(theme.palette.primary.main, ")") }));
    },
};
exports.lightError = {
    props: { variant: 'lightError' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--error-300, ".concat(theme.palette.error.light, ")"), color: "var(--error-700, ".concat(theme.palette.error.dark, ")"), border: "1px solid var(--error-700, ".concat(theme.palette.error.dark, ")") }));
    },
};
exports.lightSuccess = {
    props: { variant: 'lightSuccess' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--success-300, ".concat(theme.palette.success.light, ")"), color: "var(--success-700, ".concat(theme.palette.success.dark, ")"), border: "1px solid var(--success-700, ".concat(theme.palette.success.dark, ")") }));
    },
};
exports.lightWarning = {
    props: { variant: 'lightWarning' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: "var(--warning-300, ".concat(theme.palette.warning.light, ")"), color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), border: "1px solid var(--warning-700, ".concat(theme.palette.warning.dark, ")") }));
    },
};
exports.lightHightContrast = {
    props: { variant: 'lightHC' },
    style: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'badgeLabel')), { backgroundColor: 'transparent', color: "var(--text-light, ".concat(theme.palette.text.light, ")"), border: "1px solid var(--text-light, ".concat(theme.palette.text.light, ")") }));
    },
};
